<template>
  <div class="footer">
    <div class="footerContent">
      <div class="footer__column">
        <router-link
          class="column__heading"
          tag="span"
          :to="{name: isLoggedIn ? 'campaigns' : 'auth'}"
        >
          Wowzi
        </router-link>
        <span class="column__text address">4th Floor, Gateway Place, Milimani Road, Nairobi</span>
        <span class="column__text address"><a href="tel:+254729998980" >+254729998980</a></span>
        <span class="column__text">
          <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=support@wowzi.co"
            target="_blank"
          >support@wowzi.co</a>
        </span>
      </div>
      <div class="footer__column">
        <router-link
          class="column__text"
          tag="span"
          :to="{name: 'faq'}"
        >
          FAQ
        </router-link>
        <router-link
          class="column__text"
          tag="span"
          :to="{name: 'terms-and-conditions'}"
        >
          Terms and Conditions
        </router-link>
        <router-link
          class="column__text"
          tag="span"
          :to="{name: 'privacypolicy'}"
        >Privacy policy</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'Footer',
    computed: {
      ...mapState('Auth', [
        'isLoggedIn',
      ]),
    },
  };
</script>

<style lang="scss">
  @import "../../node_modules/bulma/sass/utilities/mixins";
  @import "../assets/styles/variables";

  .footer {
    height: 144px;
    width: 100%;
    background-color: $primary-main;
    display: flex;
    padding: 0 420px;
    justify-content: space-between;

    @include desktop-only {
      padding: 0 300px;
    }

    @include touch {
      flex-direction: column;
      height: auto;
      padding: 16px;
    }
    .footerContent {
      display: flex;
      width: 850px;
      justify-content: space-between;
      margin: 0 auto;
      @media (max-width: 1440px) {
        width: 100%;
        margin: 0 auto;
      }
      @media (max-width: 767px) {
        width: 100%;
        margin: 0 auto;
        flex-direction: column;
      }
    }
    .footer__column {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-end;
      color: $background-4;
      padding: 24px 0 24px 0;

      @include touch {
        padding: 0 0 16px;
      }
    }

    .column__heading {
      cursor: pointer;
      font-family: 'Roboto', sans-serif;
      font-weight: bold;
      padding: 0;
      font-size: 14px;
      line-height: 18px;
    }

    .column__text {
      cursor: pointer;
      font-family: 'Roboto', sans-serif;
      padding-top: 8px;
      font-size: 14px;
      line-height: 18px;
      a {
        color: white;
      }
    }
    .address {
      cursor: default;
    }
  }
</style>
